import * as types from '../../../../lib/actionTypes.es6';

export const initialState = {
  cancellationRequests: [],
  loader: false,
  errors: null,
  page: 1,
  size: 10,
  total: 0,

  updateLoader: false,
  updateSuccess: false,
  updateError: null,
};

export default function policyCancellationReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_POLICY_CANCELLATION_REQUESTS_REQUEST:
      return { ...state, loader: true, errors: null, cancellationRequests: [] };

    case types.GET_POLICY_CANCELLATION_REQUESTS_SUCCESS:
      return {
        ...state,
        loader: false,
        errors: null,
        cancellationRequests: action.payload.data || action.payload,
        page: action.payload.page || 1,
        size: action.payload.size || 10,
        total: action.payload.total || 0,
      };

    case types.GET_POLICY_CANCELLATION_REQUESTS_FAILURE:
      return { ...state, loader: false, errors: action.payload };

    case types.UPDATE_POLICY_CANCELLATION_REQUEST:
      return { ...state, updateLoader: true, updateError: null, updateSuccess: false };

    case types.UPDATE_POLICY_CANCELLATION_SUCCESS:
      return { ...state, updateLoader: false, updateSuccess: true, updateError: null };

    case types.UPDATE_POLICY_CANCELLATION_FAILURE:
      return { ...state, updateLoader: false, updateError: action.payload, updateSuccess: false };

    case types.RESET_UPDATE_POLICY_CANCELLATION_SUCCESS:
      return { ...state, updateSuccess: false };

    case types.RESET_UPDATE_POLICY_CANCELLATION_ERROR:
      return { ...state, updateError: null };

    default:
      return state;
  }
}
